<template>
  <ClientOnly>
    <Dialog :open="isOpen" @close="isOpen = false" relative z-50>
      <div fixed inset-0 bg-gray bg-opacity-20 backdrop-blur-sm flex items-center justify-center p-4>
        <DialogPanel
          class="w-[calc(100vw - 2rem)] max-w-sm max-h-screen overflow-scroll m-4 rounded bg-white p4 absolute z-2 border-2 border-stone-100 bg-white shadow-lg rounded-4 z-10 overflow-auto space-y-4"
        >
          <DialogTitle text-xl mb-4 font-500>Location Access Disabled</DialogTitle>
          <DialogDescription
            >You must enable location access for this site in your browser to use your GPS location</DialogDescription
          >
          <p>This site will only use your location to lookup your requested information.</p>
          <Button @click="isOpen = false">Continue</Button>
        </DialogPanel>
      </div>
    </Dialog>
  </ClientOnly>
</template>
<script setup>
import { Dialog, DialogPanel, DialogTitle, DialogDescription } from "@headlessui/vue";

const isOpen = ref(false);
const { locationPermissionStatus } = useLocation();

watch(locationPermissionStatus, (status) => {
  if (status === "allowed") {
    isOpen.value = false;
  }
});

// listen for events to open the dialog
onMounted(() => {
  window.addEventListener("location-disabled", () => {
    isOpen.value = true;
  });
});

// remove the listener when the component is unmounted
onUnmounted(() => {
  window.removeEventListener("location-disabled", () => {
    isOpen.value = true;
  });
});
</script>
